/* eslint-disable no-useless-escape */
export const formatsEnum = {
  FORMAT_DATE_1: 'DD-MM-YYYY',
  FORMAT_DATE_2: 'YYYY-MM-DD',
  FORMAT_DATE_3: 'YYYY/MM/DD',
  FORMAT_DATE_4: 'DD/MM/YYYY',
};

export const formatRegex = {
  [formatsEnum.FORMAT_DATE_2]:
    /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/,
  [formatsEnum.FORMAT_DATE_4]:
    /^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/\-]\d{4}$/,
};

export const notification = {
  ERROR: 'No pudimos procesar la solicitud, intente nuevamente.',
  SUCCESS: 'Operación realizada con éxito',
};

export const constantsSession = {
  ACCESS_TOKEN: 'access_token',
  ACCESS_TOKEN_DATE: 'access_token_date',
  ACCESS_TOKEN_EXPIRE_IN: 'access_token_expires_in',
  REFRESH_TOKEN: 'refresh_token',
  ROLES_ME: 'roles_me',
  ROLES_PERMISSIONS: 'roles_permissions',
  USER_INFO: 'user_info',
  PROVIDER_NAME: 'ispr'
};
